export const GET_ALL_SMS_SEND_CONFIG = "GET_ALL_SMS_SEND_CONFIG"
export const CREATE_SMS_SEND_CONFIG = "CREATE_SMS_SEND_CONFIG"
export const UPDATE_SMS_SEND_CONFIG = "UPDATE_SMS_SEND_CONFIG"
export const DELETE_SMS_SEND_CONFIG = "DELETE_SMS_SEND_CONFIG"
export const SELECT_SMS_SEND_CONFIG = "SELECT_SMS_SEND_CONFIG"
